import React from 'react';
import PropTypes from 'prop-types';
import HighchartsReact from 'highcharts-react-official';

const Highcharts = window.Highcharts;

function CallPercentages({ chartData }) {
  return (
    <div className='row row_spacer'>
      <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
        <div className='report_data_container' style={{ height: '450px' }}>
          <div className='report-data-title'>General Stats</div>
          <div className='sub_report_data_container'>
            <div className='row'>
              <div className='col-xs-12 col-sm-2 col-sm-offset-1'>
                <ConnectedPercentageGraph data={chartData[0].connected_percentage} />
              </div>
              <div className='col-xs-12 col-sm-2'>
                <MissedCallPercentageGraph data={chartData[0].missed_percentage} />
              </div>
              <div className='col-xs-12 col-sm-2'>
                <ProspectsPercentageGraph data={chartData[0].prospect_percentage} />
              </div>
              <div className='col-xs-12 col-sm-2'>
                <AppointmentOfferedPercentageGraph
                  data={chartData[0].appointmentofferedstr_percentage}
                />
              </div>
              <div className='col-xs-12 col-sm-2'>
                <SalesAppointmentPercentageGraph data={chartData[0].sales_appt_percentage} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CallPercentages.propTypes = {
  chartData: PropTypes.arrayOf(
    PropTypes.exact({
      connected_percentage: PropTypes.number,
      missed_percentage: PropTypes.number,
      prospect_percentage: PropTypes.number,
      sales_appt_percentage: PropTypes.number,
      appointmentofferedstr_percentage: PropTypes.number,
    })
  ).isRequired,
};

function ConnectedPercentageGraph({ data }) {
  let percentage = data ? data : 0;

  let color = '';
  if (percentage >= 95) {
    color = 'green';
  } else if (percentage >= 90 && percentage <= 94) {
    color = '#f5a362';
  } else {
    color = 'red';
  }

  const chartOptions = {
    chart: {
      height: 300,
      type: 'pie',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      verticalAlign: 'middle',
      floating: true,
      text: percentage + '%',
    },
    subtitle: {
      text: '',
    },
    yAxis: {
      title: {
        text: '',
      },
    },
    plotOptions: {
      size: '50%',
      pie: {
        shadow: true,
        center: ['50%', '50%'],
        startAngle: 90,
      },
    },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
      valueSuffix: '%',
    },
    series: [
      {
        name: 'Connected Percentage',
        data: [
          ['', 100 - percentage],
          ['', percentage],
        ],
        size: '60%',
        innerSize: '75%',
        colors: ['#bbbbbb', color],
        dataLabels: {
          enabled: false,
          formatter: function () {
            // display only if larger than 1
            return this.y > 1 ? '<b>' + this.point.name + ':</b> ' + this.y + '%' : null;
          },
        },
        id: 'versions',
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 100,
          },
          chartOptions: {
            legend: {
              enabled: false,
            },
          },
        },
      ],
    },
  };
  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      <div className='percentage-bar-title'>Connected Calls</div>
    </div>
  );
}

ConnectedPercentageGraph.propTypes = { data: PropTypes.number };

function MissedCallPercentageGraph({ data }) {
  let percentage = data ? data : 0;

  let color = '';
  if (percentage <= 3) {
    color = 'green';
  } else if (percentage < 10) {
    color = '#f5a362';
  } else {
    color = 'red';
  }

  const chartOptions = {
    chart: {
      height: 300,
      type: 'pie',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      verticalAlign: 'middle',
      floating: true,
      text: percentage + '%',
    },
    subtitle: {
      text: '',
    },
    yAxis: {
      title: {
        text: '',
      },
    },
    plotOptions: {
      size: '50%',
      pie: {
        shadow: true,
        center: ['50%', '50%'],
        startAngle: 90,
      },
    },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
      valueSuffix: '%',
    },
    series: [
      {
        name: 'Missed Percentage',
        data: [
          ['', 100 - percentage],
          ['', percentage],
        ],
        size: '60%',
        innerSize: '75%',
        colors: ['#bbbbbb', color],
        dataLabels: {
          enabled: false,
          formatter: function () {
            // display only if larger than 1
            return this.y > 1 ? '<b>' + this.point.name + ':</b> ' + this.y + '%' : null;
          },
        },
        id: 'versions',
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 100,
          },
          chartOptions: {
            legend: {
              enabled: false,
            },
          },
        },
      ],
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      <div className='percentage-bar-title'>Missed Calls</div>
    </div>
  );
}

MissedCallPercentageGraph.propTypes = { data: PropTypes.number };

function ProspectsPercentageGraph({ data }) {
  let percentage = data ? data : 0;

  let color = '';
  if (percentage >= 25) {
    color = 'green';
  } else if (percentage >= 10) {
    color = '#f5a362';
  } else {
    color = 'red';
  }

  const chartOptions = {
    chart: {
      height: 300,
      type: 'pie',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      verticalAlign: 'middle',
      floating: true,
      text: percentage + '%',
    },
    subtitle: {
      text: '',
    },
    yAxis: {
      title: {
        text: '',
      },
    },
    plotOptions: {
      size: '50%',
      pie: {
        shadow: true,
        center: ['50%', '50%'],
        startAngle: 90,
      },
    },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
      valueSuffix: '%',
    },
    series: [
      {
        name: 'Prospect Percentage',
        data: [
          ['', 100 - percentage],
          ['', percentage],
        ],
        size: '60%',
        innerSize: '75%',
        colors: ['#bbbbbb', color],
        dataLabels: {
          enabled: false,
          formatter: function () {
            // display only if larger than 1
            return this.y > 1 ? '<b>' + this.point.name + ':</b> ' + this.y + '%' : null;
          },
        },
        id: 'versions',
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 100,
          },
          chartOptions: {
            legend: {
              enabled: false,
            },
          },
        },
      ],
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      <div className='percentage-bar-title'>Sales Prospects</div>
    </div>
  );
}

ProspectsPercentageGraph.propTypes = { data: PropTypes.number };

function AppointmentOfferedPercentageGraph({ data }) {
  let percentage = data ? data : 0;

  let color = '';
  if (percentage >= 80) {
    color = 'green';
  } else if (percentage >= 60) {
    color = '#f5a362';
  } else {
    color = 'red';
  }

  const chartOptions = {
    chart: {
      height: 300,
      type: 'pie',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      verticalAlign: 'middle',
      floating: true,
      text: percentage + '%',
    },
    subtitle: {
      text: '',
    },
    yAxis: {
      title: {
        text: '',
      },
    },
    plotOptions: {
      size: '50%',
      pie: {
        shadow: true,
        center: ['50%', '50%'],
        startAngle: 90,
      },
    },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
      valueSuffix: '%',
    },
    series: [
      {
        name: 'Appt Offered Percentage',
        data: [
          ['', 100 - percentage],
          ['', percentage],
        ],
        size: '60%',
        innerSize: '75%',
        colors: ['#bbbbbb', color],
        dataLabels: {
          enabled: false,
          formatter: function () {
            // display only if larger than 1
            return this.y > 1 ? '<b>' + this.point.name + ':</b> ' + this.y + '%' : null;
          },
        },
        id: 'versions',
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 100,
          },
          chartOptions: {
            legend: {
              enabled: false,
            },
          },
        },
      ],
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      <div className='percentage-bar-title'>Appointment Offered</div>
    </div>
  );
}

AppointmentOfferedPercentageGraph.propTypes = { data: PropTypes.number };

function SalesAppointmentPercentageGraph({ data }) {
  let percentage = data ? data : 0;

  let color = '';
  if (percentage >= 20) {
    color = 'green';
  } else if (percentage >= 15) {
    color = '#f5a362';
  } else {
    color = 'red';
  }

  const chartOptions = {
    chart: {
      height: 300,
      type: 'pie',
      margin: [0, 0, 0, 0],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
    },
    title: {
      verticalAlign: 'middle',
      floating: true,
      text: percentage + '%',
    },
    subtitle: {
      text: '',
    },
    yAxis: {
      title: {
        text: '',
      },
    },
    plotOptions: {
      size: '50%',
      pie: {
        shadow: true,
        center: ['50%', '50%'],
        startAngle: 90,
      },
    },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
      valueSuffix: '%',
    },
    series: [
      {
        name: 'Sales Appt Percentage',
        data: [
          ['', 100 - percentage],
          ['', percentage],
        ],
        size: '60%',
        innerSize: '75%',
        colors: ['#bbbbbb', color],
        dataLabels: {
          enabled: false,
          formatter: function () {
            // display only if larger than 1
            return this.y > 1 ? '<b>' + this.point.name + ':</b> ' + this.y + '%' : null;
          },
        },
        id: 'versions',
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 100,
          },
          chartOptions: {
            legend: {
              enabled: false,
            },
          },
        },
      ],
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      <div className='percentage-bar-title'>Sales Appointment</div>
    </div>
  );
}

SalesAppointmentPercentageGraph.propTypes = { data: PropTypes.number };

export default CallPercentages;
